import dd, { biz, config, error, ready } from 'dingtalk-jsapi'
import {
  _authentication
} from '@/api/user'
import { deviceInfo } from '@/utils/initial'

window.dd = dd

// 从loaclStorage获取corpid
export const gainCorpid = () => {
  return localStorage.getItem('CORP_ID')
}

// api权限验证
function getDDAPIAuthed(cId, flag) {
  const corpId = cId || gainCorpid()
  return new Promise((resolve, reject) => {
    const path = window.location.href
    const href = deviceInfo.isAndroid && flag !== 'retry'
      ? localStorage.getItem('SOURCE_HREF') || path
      : path
    const params = { url: href.split('#')[0], corpId }
    _authentication(params).then(([success, result]) => {
      if (success) {
        const { agentId, corpId, timeStamp, nonceStr, signature } = result || {}
        config({
          agentId,
          corpId,
          timeStamp,
          nonceStr,
          signature,
          jsApiList: [
            'openChatByUserId',
            'biz.clipboardData.setData',
          ] // 必填，需要使用的jsapi列表
        })
        /** 当config权限校验成功时触发 */
        ready(() => {
          resolve(result)
        })
        /** 当config权限校验失败时触发 */
        error(e => {
          if (e.errorCode === 3 && flag !== 'retry') {
            getDDAPIAuthed(corpId, 'retry')
          }
        })
      }
    }).catch(err => {
      reject(err)
    })
  })
}

const setTitle = {
  execute (title) {
    return new Promise((resolve, reject) => {
      document.title = title
      resolve()
    })
  }
}

const openChatByUserId = {
  execute(obj = {}) {
    return new Promise((res, rej) => {
      dd.openChatByUserId({
        corpId: gainCorpid(),
        ...obj,
        success: d => {res(d)},
        fail: e => {rej(e)}
      })
    })
  }
}

// 复制内容到粘贴板
const setClipboardData = {
  execute (text) {
    return new Promise((resolve, reject) => {
      const params = {
        text,
        onSuccess: result => {
          resolve(result)
        },
        onFail: () => {
        }
      }
      biz.clipboardData.setData(params).catch(e => { reject(e) })
    })
  }
}

// 是否过期 后端默认7000s 前台默认6900s
function isExpire(timer, target = 6900 * 1000) {
  const now = new Date().getTime()
  return now - timer <= target
}

// 命令列表
const commandList = {
  openChatByUserId,
  setTitle,
  'setClipboardData': setClipboardData
}

/**
 * 设置命令
 * @param {String} command 执行命令字段
 * @param {Object} obj  鉴权默认参数
 */
export const setCommand = (() => {
  let commandObj = null
  return async (command, obj) => {
    if (commandObj) {
      if (isExpire(commandObj.timer)) {
        return commandList[command].execute(obj)
      }
    }
    await getDDAPIAuthed()
    // 鉴权成功缓存数据
    commandObj = {
      execute: commandList[command].execute,
      timer: new Date().getTime()
    }
    return commandList[command].execute(obj)
  }
})()
